import { Component, Input, OnDestroy } from '@angular/core';
import { TokenService } from '../../services/token.service';
import { CompanyV2Dto } from 'src/app/api-client';
import { environment } from 'src/environments/environment';
import { Subscription } from 'rxjs';
@Component({
  selector: 'app-logo',
  templateUrl: './logo.component.html',
  styleUrls: ['./logo.component.scss'],
})
export class LogoComponent implements OnDestroy {
  @Input() verticalPosition: boolean = false;

  public company: CompanyV2Dto;

  public baseUrl = environment.url;

  public subs: Subscription;

  constructor(private _token: TokenService) {
    this.company = _token.getUser().company;

    this.subs = this._token.getLogo().subscribe({
      next: (logo) => {
        this.company.placeInformation.logo = logo;
      },
    });
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }
}
